import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { mapProductFieldsToBody } from './mappers/productMapper';
import type { CreateProductParams, ProductAdminResponse } from './types';

export async function createProduct(params: CreateProductParams) {
  const url = '/web/studio/products';

  const { price, ...fields } = params;
  const body = { ...mapProductFieldsToBody(fields), price };

  const response = await api.executePostRequest<ObjectResponse<ProductAdminResponse>>(url, body);

  return response.data;
}
